import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { NavLink as RouterLink } from 'react-router-dom';

// @mui
import { Box, List, Tooltip, ListItemText } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

//
import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
  isExpanded: PropTypes.bool,
};

export default function NavSection({ data = [], isExpanded = true, ...other }) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item) => (
          <NavItem key={item.title} item={item} isExpanded={isExpanded} />
        ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
  isExpanded: PropTypes.bool,
};

function NavItem({ item, isExpanded }) {
  const { t } = useTranslation();
  const { isSmallScreen } = useResponsiveScreen();
  const { title, path, icon, info } = item;

  return (
    <Tooltip title={!isExpanded ? t(`nav.${title}`) : ''} placement="right" arrow>
      <span>
        <StyledNavItem
          component={RouterLink}
          to={path}
          sx={{
            '&.active': {
              color: 'text.primary',
              bgcolor: 'action.selected',
              fontWeight: 'fontWeightBold',
              maxHeight: isSmallScreen && 40,
            },
            justifyContent: isExpanded ? 'flex-start' : 'center',
            px: isExpanded ? 2.5 : 1,
          }}
        >
          <StyledNavItemIcon
            sx={{
              width: isSmallScreen ? 20 : 22,
              height: isSmallScreen ? 20 : 22,
              mr: isExpanded ? 2 : 0,
            }}
          >
            {icon && icon}
          </StyledNavItemIcon>

          <ListItemText
            disableTypography
            primary={t(`nav.${title}`)}
            sx={{
              fontSize: isSmallScreen ? '0.725rem' : '0.875rem',
              opacity: isExpanded ? 1 : 0,
              transition: 'opacity 0.2s ease',
            }}
          />

          {isExpanded && info && info}
        </StyledNavItem>
      </span>
    </Tooltip>
  );
}
